import { create } from "zustand";

interface AudioPlayerStore {
  playingInstanceId: string | null;
  setPlayingInstanceId: (id: string | null) => void;
}

export const useAudioPlayerStore = create<AudioPlayerStore>((set) => ({
  playingInstanceId: null,
  setPlayingInstanceId: (id) => set({ playingInstanceId: id }),
}));
